import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/index';
import NotificationPlugin from '@/plugins/notifications';
import TooltipDirective from '@/directives/tooltip';
import RevealDirective from '@/directives/reveal';
import {CommonMixin} from "@/mixins/commonMethods";
import { initYandexMetrika } from 'yandex-metrika-vue3'

import { createHead } from '@vueuse/head';


const app = createApp(App);

const head = createHead();
app.use(head);
app.directive('tooltip', TooltipDirective);
app.directive('reveal', RevealDirective);

app.use(initYandexMetrika, {
    id: '104121509',
    router: router,
    env: "production",
    webvisor: true,
    clickmap: true,
})

// Установим обработчик ошибок именно в новом экземпляре приложения
// app.config.errorHandler = (err, vm, info) => {
//     console.error(`Ошибка: ${info}`, err.stack);
// };

app.config.errorHandler = (err, vm, info) => {
    console.error('Unhandled error:', err);
    console.info('From component:', vm);
    console.debug('Additional info:', info);
}

app.mixin(CommonMixin);
app.use(NotificationPlugin);

app.use(router);
app.use(store);
app.mount('#app');
